<script setup lang="ts">
import FormError from "./FormError.vue";

interface Props {
    errors?: Array<string>|null,

}
const props = withDefaults(defineProps<Props>(), {
    errors: []
});
</script>

<template>
    <div>
        <FormError v-for="error in errors" key="" :error="error" />
    </div>
</template>
